"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _ifOnly = _interopRequireDefault(require("if-only"));

var _enhanceFormControl = _interopRequireDefault(require("./enhance-form-control"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var classNameCheckbox = function classNameCheckbox(props) {
  return (0, _classnames.default)('Checkbox', {
    'Checkbox--disabled': props.disabled
  }, props.className);
};

var classNameLabel = function classNameLabel(props) {
  return (0, _classnames.default)('LabelCheckbox', {
    'LabelCheckbox--disabled': props.disabled
  }, {
    'LabelCheckbox--on-the-left': props.labelPosition === 'left'
  });
};

var Checkbox = function Checkbox(props) {
  var onChange = props.onChange,
      checked = props.checked,
      value = props.value,
      id = props.id,
      children = props.children,
      onClick = props.onClick;
  var isChecked = !!checked || !!value;

  var handleOnChange = function handleOnChange(e) {
    e.stopPropagation();
    onChange ? onChange(!isChecked, e.target.name) : null;
  };

  var uniqId = id ? id : (0, _v.default)();
  return _react.default.createElement("label", {
    className: classNameLabel(props),
    htmlFor: uniqId,
    onClick: onClick
  }, _react.default.createElement("div", {
    className: classNameCheckbox(props)
  }, _react.default.createElement("input", _extends({}, (0, _omit.default)(props, ['children', 'labelPosition', 'error']), {
    checked: isChecked,
    id: uniqId,
    type: "checkbox",
    className: "Checkbox__input",
    onChange: handleOnChange
  })), _react.default.createElement("div", {
    className: "Checkbox__sprite"
  }, _react.default.createElement("label", {
    className: "Checkbox__label",
    htmlFor: uniqId
  }, _react.default.createElement("i", {
    className: "dbi dbi-check-bold"
  })))), children ? _react.default.createElement("div", {
    className: "LabelCheckbox__label"
  }, children) : void 0);
};

var _default = (0, _enhanceFormControl.default)(Checkbox);

exports.default = _default;